<template>
  <div
    :class="{
      'bg-dark text-white': background === 'dark',
      'bg-light-white': background === 'light',
    }"
    class="max-w-[100vw] overflow-hidden"
    v-editable="blok"
  >
    <div v-if="heading" class="container mb-12 lg:mb-20">
      <h2 class="text-5xl md:text-6xl font-secondary">{{ heading }}</h2>
    </div>

    <div class="container-fluid relative aspect-video h-[80vh] w-full md:max-w-[95vw]">
      <MapBlockRenderer
        :latitude="latitude"
        :longitude="longitude"
        :showAllVenues="showAllVenues"
        :map-style="mapboxStyle"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { MapBlockProps } from '~/types/MapBlock';
import MapBlockRenderer from './MapBlockRenderer.vue';

const { blok } = defineProps<{ blok: MapBlockProps }>();
const { latitude, longitude, heading, background, showAllVenues } = blok;

const runtimeConfig = useRuntimeConfig();
const { mapboxStyle } = runtimeConfig.public;
</script>
